import { connect } from 'react-redux';
import { goBack, push, routerActions } from 'react-router-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {logout} from '../../app/session';
import IsSpinning from '../../app/containers/IsSpinning';
import Spinner from '../../app/components/Spinner';
import Page from '../../app/components/Page';
import {SessionAwareComponent} from "../../../lib/api/components/SessionAwareComponent";

export class Logout extends SessionAwareComponent {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        redirectRoute: PropTypes.string,
    }

    componentWillMount() {
        this.props.dispatch(logout());
    }

    handleSubmitSuccess = () => {
        this.props.dispatch(goBack());
    }

    onSessionChange(prevSession, session) {
        if (!session || !session.get('authenticated')) {
            // The initial store state is passed by Laravel on the base view. To reset the
            // store we have to hard-redirect so laravel injects the new state after logout.
            window.location.href = '/auth/login';
            return null;
        }
    }

    render() {
        return (<Page.Body>
            <IsSpinning id='logout'>
                <Spinner />
            </IsSpinning>
        </Page.Body>);
    }
}

export default connect((state) => ({
    form: state.form,
    session: state.session,
    dispatch: state.dispatch,
}))(Logout);
